var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTypeCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36534_5473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03334 13.8337C6.54445 13.8337 5.27778 13.317 4.23334 12.2837C3.18889 11.2503 2.66667 9.98921 2.66667 8.50033V8.38366L1.60001 9.45033L0.666672 8.51699L3.33334 5.85033L6 8.51699L5.06667 9.45033L4 8.38366V8.50033C4 9.61144 4.39167 10.5559 5.175 11.3337C5.95834 12.1114 6.91112 12.5003 8.03334 12.5003C8.32223 12.5003 8.60556 12.467 8.88334 12.4003C9.16112 12.3337 9.43334 12.2337 9.7 12.1003L10.7 13.1003C10.2778 13.3448 9.84445 13.5281 9.4 13.6503C8.95556 13.7725 8.5 13.8337 8.03334 13.8337ZM12.6667 11.1503L10 8.48366L10.9333 7.55033L12 8.61699V8.50033C12 7.38921 11.6083 6.44477 10.825 5.66699C10.0417 4.88921 9.08889 4.50033 7.96667 4.50033C7.67778 4.50033 7.39445 4.53366 7.11667 4.60033C6.83889 4.66699 6.56667 4.76699 6.3 4.90033L5.3 3.90033C5.72223 3.65588 6.15556 3.47255 6.6 3.35033C7.04445 3.2281 7.5 3.16699 7.96667 3.16699C9.45556 3.16699 10.7222 3.68366 11.7667 4.71699C12.8111 5.75033 13.3333 7.01144 13.3333 8.50033V8.61699L14.4 7.55033L15.3333 8.48366L12.6667 11.1503Z",
    fill: "#278176"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36534_5473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeCopy);
export default __webpack_public_path__ + "static/media/icon_type_copy.90f9eb1b77dc9fee2a2021ccb30eab6b.svg";
export { ForwardRef as ReactComponent };